import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/* ═══════════════════════════════════════════════════════════════════════════════
   BIRKENSTOCK × WUNDER — Ekim · Kasım · Aralık 2026 İŞ BİRLİĞİ TEKLİFİ
   Salomon × Wunder teklifiyle (SalomonWunderEylulKasim2026.jsx) aynı kurgu:
   Aylık ₺150.000 medya (Meta ₺90K + Google ₺60K).
   NOT (12 Eki 2026): Salomon'daki First Banner + e-posta (owned envanter) bu
   teklifte İPTAL edildi — sayfada yalnız performans medyası var.

   BİRİM MALİYETLER WUNDER'IN KENDİ GERÇEKLEŞEN VERİSİNDEN (12 Eki 2026'da çekildi):
   · unified_ad_platform_daily_summary, Eki 2025–Eyl 2026:
     Meta CPM ₺76,8 / CPC ₺1,45 · Google CPM ₺126,8 / CPC ₺3,64
     Geçen yıl Eki–Ara Meta CPM ortalaması ₺74,9 (₺63,9 · ₺86,4 · ₺74,4) → tek markaya daraltma için +%30.
     Google CPC Eyl 2026'da ₺5,00'a çıktı; plan CPC'leri bu güncel seviyeden.
   · Gösterim = bütçe / CPM × 1000, tıklama = gösterim × CTR (Google'da bütçe / CPC).
   Uydurulmuş envanter rakamı YOKTUR.
   ═══════════════════════════════════════════════════════════════════════════════ */

export default function BirkenstockWunderEkimAralik2026() {
  const kartRef = useRef(null);
  const [indiriliyor, setIndiriliyor] = useState(false);

  const pdfIndir = async () => {
    if (!kartRef.current || indiriliyor) return;
    setIndiriliyor(true);
    await new Promise((r) => setTimeout(r, 200)); // stil değişimi boyansın
    try {
      const tuval = await html2canvas(kartRef.current, {
        scale: 2, backgroundColor: '#ffffff', useCORS: true, logging: false,
        imageTimeout: 15000, windowWidth: kartRef.current.scrollWidth,
      });
      const g = tuval.width / 2, y = tuval.height / 2;
      const pdf = new jsPDF({ orientation: g > y ? 'landscape' : 'portrait', unit: 'px', format: [g, y] });
      pdf.addImage(tuval.toDataURL('image/jpeg', 0.95), 'JPEG', 0, 0, g, y);
      pdf.save('birkenstock-wunder-ekim-aralik-2026.pdf');
    } catch (e) {
      alert(`PDF alınamadı: ${e.message}`);
    } finally {
      setIndiriliyor(false);
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-4 flex justify-end">
        <button
          onClick={pdfIndir}
          disabled={indiriliyor}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-800 text-white text-sm font-semibold hover:bg-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {indiriliyor ? 'Hazırlanıyor…' : 'PDF İndir'}
        </button>
      </div>
      <div ref={kartRef} className="bg-white rounded-2xl shadow-sm border overflow-hidden">

        {/* ─────────────────────────── BAŞLIK ─────────────────────────── */}
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="flex flex-shrink-0 items-center gap-4 pr-5 border-r border-gray-200">
              <img src="/birkenstock_logo.png" alt="Birkenstock" className="h-5 w-auto object-contain" />
              <span className="text-gray-300 text-xl font-light leading-none">×</span>
              <img src="/wunderlogo.webp" alt="Wunder" className="h-4 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">Birkenstock × Wunder | Ekim · Kasım · Aralık 2026 İş Birliği Teklifi</h2>
              <p className="text-sm text-gray-500">
                Aylık ₺150.000 performans medyası (Meta + Google) • 3 ay
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-block whitespace-nowrap px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Eki – Ara 2026
            </span>
            <span className="inline-block whitespace-nowrap px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              3 Ay Toplam: ₺450.000
            </span>
          </div>
        </div>

        <div className="p-6">

          {/* ─────────────────────── TEKLİF ÖZETİ ─────────────────────── */}
          <div className="mb-8 rounded-xl border-2 border-gray-800 overflow-hidden">
            <div className="bg-gray-800 px-4 py-3 text-white font-semibold">Teklif Özeti | Aylık Paket</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2.5 text-left font-medium uppercase tracking-wider text-[11px]">Kalem</th>
                    <th className="px-4 py-2.5 text-left font-medium uppercase tracking-wider text-[11px]">Kapsam</th>
                    <th className="px-4 py-2.5 text-right font-medium uppercase tracking-wider text-[11px]">Aylık Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-3 font-medium">Meta Ads | medya</td>
                    <td className="px-4 py-3">Advantage+ Katalog · Retargeting · Sezon seçkisi | <strong>ağırlık ürün feed'inde</strong> + Reels</td>
                    <td className="px-4 py-3 text-right font-semibold">₺90.000</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-medium">Google Ads | medya</td>
                    <td className="px-4 py-3">Search (marka + kategori) · Shopping / PMax | <strong>feed tabanlı</strong></td>
                    <td className="px-4 py-3 text-right font-semibold">₺60.000</td>
                  </tr>
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3">AYLIK TOPLAM</td>
                    <td className="px-4 py-3 font-normal text-[11px] text-gray-300">Performans medyası (Meta + Google)</td>
                    <td className="px-4 py-3 text-right text-lg">₺150.000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* ─────────────── MEDYA PLANI ─────────────── */}
          <div className="mb-8 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Aylık Medya Planı | ₺150.000 (Meta ₺90.000 + Google ₺60.000)</div>
            <div className="px-4 py-3 bg-violet-50 border-b border-violet-100 text-[11px] text-violet-900 leading-relaxed">
              <strong>Kış dönemi Birkenstock'ta Boston'ın sezonudur.</strong> Son 12 ayda Wunder'daki Birkenstock cirosunun{' '}
              <strong>%65'i</strong> Boston ailesinden geldi; bu yüzden kurgu kapalı modeller (Boston, Utti, Naples, Arizona Fur)
              üzerine kuruludur. Bütçenin büyük kısmı Wunder'ın Merchant Center ve Meta kataloğundaki <strong>gerçek ürün
              görselleri, fiyatları ve stok durumu</strong> ile çalışan feed kampanyalarına ayrıldı. Tek video kalemi
              (Reels) Birkenstock'un hazır sezon içerikleriyle çalışır, yeni prodüksiyon gerektirmez.
              Ay ay odak: <strong>Ekim</strong> kış sezonu açılışı · <strong>Kasım</strong> Black Friday · <strong>Aralık</strong> yılbaşı hediyesi.
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aylık Tahmini Çıktı</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={4}>
                      <div className="flex items-center gap-2"><img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" /><span>Meta Ads</span></div>
                    </td>
                    <td className="px-4 py-3">Advantage+ Katalog | Prospecting</td>
                    <td className="px-4 py-3">Geniş + benzer kitle · Birkenstock ürün seti izole katalog · ürün görseli feed'den</td>
                    <td className="px-4 py-3">400.000 gösterim · 16.000 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium">₺38.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Advantage+ Katalog | Retargeting (DPA)</td>
                    <td className="px-4 py-3">Birkenstock ürün sayfası görüntüleyen + sepete ekleyen (30 gün) · dinamik ürün hatırlatma</td>
                    <td className="px-4 py-3">191.304 gösterim · 9.565 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium">₺22.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Katalog | Sezon Seçkisi</td>
                    <td className="px-4 py-3">Feed'den otomatik kurulur | Ekim Boston + kürklü modeller, Kasım BF ürün grubu, Aralık hediye seçkisi</td>
                    <td className="px-4 py-3">150.000 gösterim · 6.000 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium">₺15.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Reels | Sezon İçeriği</td>
                    <td className="px-4 py-3">Birkenstock'un hazır kış videoları · 25–44 yaş, moda + sneaker ilgi alanı · Wunder sayfasından</td>
                    <td className="px-4 py-3">187.500 gösterim · 2.250 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium">₺15.000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={3}>Meta Ads Toplam</td>
                    <td className="px-4 py-3">928.804 gösterim · 33.815 tıklama · CPM ₺96,9 · CPC ₺2,66</td>
                    <td className="px-4 py-3 text-right">₺90.000</td>
                  </tr>

                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2"><img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" /><span>Google Ads</span></div>
                    </td>
                    <td className="px-4 py-3">Shopping / PMax | Birkenstock feed</td>
                    <td className="px-4 py-3">Merchant Center'da Birkenstock ürünleriyle sınırlı feed etiketi · en yüksek paylı kalem</td>
                    <td className="px-4 py-3">234.114 gösterim · 5.385 tıklama · CPC ₺5,20</td>
                    <td className="px-4 py-3 text-right font-medium">₺28.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search | Marka</td>
                    <td className="px-4 py-3">"birkenstock", "birkenstock boston", "birkenstock arizona", "birkenstock terlik" · marka + model aramaları</td>
                    <td className="px-4 py-3">82.102 gösterim · 3.448 tıklama · CPC ₺5,80</td>
                    <td className="px-4 py-3 text-right font-medium">₺20.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search | Kategori (non-brand)</td>
                    <td className="px-4 py-3">"sabo terlik", "deri sabo", "kürklü terlik", "kadın sabo"</td>
                    <td className="px-4 py-3">55.172 gösterim · 1.600 tıklama · CPC ₺7,50</td>
                    <td className="px-4 py-3 text-right font-medium">₺12.000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={3}>Google Ads Toplam</td>
                    <td className="px-4 py-3">371.388 gösterim · 10.433 tıklama · CPM ₺161,6 · CPC ₺5,75</td>
                    <td className="px-4 py-3 text-right">₺60.000</td>
                  </tr>

                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={3}>AYLIK GENEL TOPLAM</td>
                    <td className="px-4 py-3">1.300.192 gösterim · 44.248 tıklama</td>
                    <td className="px-4 py-3 text-right">₺150.000</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-3 bg-slate-50 border-t text-[11px] text-gray-600 leading-relaxed">
              Tablodaki gösterim/tıklama rakamları <strong>aylıktır</strong>.
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
